/**
 * PageContainer — canonical max-width phone column for PWA parity surfaces.
 *
 * Per foundation spec §6b: iOS only ever renders at phone aspect, and the
 * PWA's type scale is height-driven. On ultra-wide desktop that would pick
 * wrong font sizes and let cards go full-bleed. Wrapping every parity surface
 * in a centered max-width:600px column (matching `.appPadding`) keeps the
 * height-driven scale sensible and prevents overflow on wide screens.
 */
import { CSSProperties, FC, ReactNode } from "react";
import { pageMaxWidth } from "./tokens";

export interface PageContainerProps {
  children: ReactNode;
  /** Apply horizontal page padding (matches `.appPadding`). Default true. */
  padded?: boolean;
  className?: string;
  style?: CSSProperties;
}

const MAX_WIDTH = pageMaxWidth;

const PageContainer: FC<PageContainerProps> = ({
  children,
  padded = true,
  className,
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        width: "100%",
        maxWidth: MAX_WIDTH,
        marginLeft: "auto",
        marginRight: "auto",
        minHeight: "100%",
        boxSizing: "border-box",
        paddingLeft: padded ? 16 : 0,
        paddingRight: padded ? 16 : 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default PageContainer;
